<page-toolbar [title]="'userAdmin.headTitle' | translate"></page-toolbar>

<page-content [noPadding]="true">
  <data-table (detail)="onDetail($event)" [columns]="columns" [dataProvider]="organisationService" [title]="'userAdmin.title' | translate"
              [searchAll]="true" [noHeader]="true" [dataProviderParams]="params"></data-table>
</page-content>
